/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    function initRadioMirrors() {
      var wrappers = document.querySelectorAll('.template-product [data-radio-mirror-wrapper]');

      wrappers.forEach(function(wrapper) {
        var hiddenInput = wrapper.querySelector('[data-radio-mirror]');
        if (!hiddenInput) return;

        var legendValue = wrapper.querySelector('[data-radio-legend-value]');
        var radios = wrapper.querySelectorAll('[data-radio-mirror-option]');
        if (!radios.length) return;

        function updateRadioState(radio) {
          hiddenInput.value = radio.value;

          if (legendValue) {
            legendValue.textContent = radio.value;
          }
        }

        radios.forEach(function(radio) {
          if (radio.checked) {
            updateRadioState(radio);
          }

          radio.addEventListener('change', function() {
            if (this.checked) {
              updateRadioState(this);
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRadioMirrors);
    } else {
      initRadioMirrors();
    }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
